<script>

    export let icon = 'user'
    export let color = '';

</script>

<span on:click class="icon" style='color: { color }'>
    <i class="fas fa-{icon}"></i>
</span>